import React from 'react';
import { AlertCircle } from 'lucide-react';

interface ErrorDisplayProps {
  error: unknown;
  message?: string;
}

export const ErrorDisplay: React.FC<ErrorDisplayProps> = ({ error, message }) => {
  const errorMessage = message || 
    (error instanceof Error ? error.message : 'An error occurred while loading the forms.');

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="bg-red-50 border border-red-200 rounded-lg p-6">
        <div className="flex items-center space-x-3">
          <AlertCircle className="h-6 w-6 text-red-600" />
          <div>
            <h3 className="text-lg font-semibold text-red-800">Error</h3>
            <p className="text-red-600 mt-1">{errorMessage}</p>
          </div>
        </div>
      </div>
    </div>
  );
};